import { peek as _peek } from "@thi.ng/arrays";
import { map } from "./map";
export function peek(src) {
    return map(_peek, src);
}
